var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAiAgentTopbar = function SvgAiAgentTopbar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 18C36 27.9411 27.9411 36 18 36C8.05887 36 0 27.9411 0 18C0 8.05887 8.05887 0 18 0C27.9411 0 36 8.05887 36 18Z",
    fill: "url(#aiTopbar16Gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 12C18.2822 12 18.5346 12.1746 18.6338 12.4387L19.9787 16.022L23.5613 17.3657C23.8253 17.4648 23.9998 17.7174 24 17.9994C24 18.2817 23.8255 18.5352 23.5613 18.6343L19.9787 19.9769L18.6338 23.5613C18.5346 23.8254 18.2821 24 18 24C17.7179 24 17.4654 23.8254 17.3662 23.5613L16.0202 19.9769L12.4387 18.6343C12.1745 18.5352 12 18.2817 12 17.9994C12.0002 17.7174 12.1746 17.4648 12.4387 17.3657L16.0202 16.022L17.3662 12.4387L17.4103 12.3439C17.5289 12.1335 17.7531 12 18 12Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aiTopbar16Gradient",
    x1: 0,
    y1: 18,
    x2: 36,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8762FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512DEE"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAiAgentTopbar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ai-agent-topbar.42e0c68499aabaf887025075695ce725.svg";